import { Validator } from '../../../types/Validator';
import { isValidDate } from './helpers';

const errorCode = 'INVALID_DATE';

const date: Validator = value => {
  if (!isValidDate(String(value))) {
    return {
      errorCode
    };
  }
};

export { date, errorCode };
